import React from "react";

export default function PremiumFooter({ style = {} }) {
  const year = new Date().getUTCFullYear();

  return (
    <p
      style={{
        fontSize: 11,
        color: "#aeaeb2",
        lineHeight: 1.6,
        textAlign: "center",
        ...style,
      }}
    >
      © {year} Carrefour. All rights reserved.
    </p>
  );
}
